/* VanillaGoods bake log: "I made this", a private rating and note per recipe (localStorage vg_bakes_v1, synced to
   My Kitchen by vg-me.js). Shows the member's note under the recipe header. */
(function () {
  var KEY = 'vg_bakes_v1';
  var box = document.querySelector('[data-vg-bake]');
  if (!box) return;
  var id = box.getAttribute('data-id');
  var $ = function (s) { return box.querySelector(s); };
  var form = $('[data-vg-bake-form]'), status = $('[data-vg-bake-status]'), sub = $('[data-vg-bake-sub]');
  var text = $('[data-vg-bake-text]'), logBtn = $('[data-vg-bake-log]');
  var note = document.querySelector('[data-vg-bake-note]'), noteText = document.querySelector('[data-vg-bake-note-text]');
  var lastLog = null;

  function readAll() { try { return JSON.parse(window.localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function writeAll(all) {
    try {
      if (Object.keys(all).length) window.localStorage.setItem(KEY, JSON.stringify(all));
      else window.localStorage.removeItem(KEY);
    } catch (e) { status.textContent = 'Your browser is blocking saves, so this bake was not kept.'; }
  }
  function today() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function niceDay(s) { try { return new Date(s + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return s; } }
  function item() { return readAll()[id] || null; }
  function save(it) {
    var all = readAll();
    if (it) {
      it.n = (box.getAttribute('data-name') || '').slice(0, 200);
      it.u = (box.getAttribute('data-url') || '').slice(0, 290);
      it.i = (box.getAttribute('data-img') || '').slice(0, 290);
      it.k = box.getAttribute('data-vg-kind') || it.k || 'bake';   // 'drink' keeps drinks out of the baking badges in My Kitchen
      all[id] = it;
    } else delete all[id];
    writeAll(all);
  }
  function setStars(r) {
    box.querySelectorAll('[data-vg-bake-star]').forEach(function (b) {
      b.setAttribute('aria-pressed', Number(b.getAttribute('data-vg-bake-star')) <= r ? 'true' : 'false');
    });
  }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* none */ } }

  function render() {
    var it = item();
    if (it && it.c) {
      sub.textContent = "You've made this " + (it.c === 1 ? 'once' : it.c + ' times') + (it.d ? ', most recently on ' + niceDay(it.d) : '') + '.';
      logBtn.textContent = 'I made it again';
      form.hidden = false;
    } else if (it && it.t) {
      form.hidden = false;
    }
    setStars(it && it.r ? it.r : 0);
    if (text && document.activeElement !== text) text.value = (it && it.t) || '';
    if (note && noteText) {
      if (it && it.t) { noteText.textContent = it.t; note.hidden = false; } else { note.hidden = true; }
    }
  }

  logBtn.addEventListener('click', function () {
    var it = item() || { c: 0, r: 0, t: '' }, d = today();
    lastLog = JSON.parse(JSON.stringify(it));
    it.c = (it.c || 0) + 1;
    it.f = it.f || d;
    it.d = d;
    it.h = ((it.h ? String(it.h) + ',' : '') + d).split(',').slice(-26).join(',');   // bake dates for the weekly rhythm
    save(it);
    render();
    status.innerHTML = 'Logged in My Kitchen. <button type="button" class="vg-bake__undo" data-vg-bake-undo>Undo</button>';
    track('bake_logged', { article_id: id, count: it.c });
  });
  box.addEventListener('click', function (e) {
    var star = e.target.closest('[data-vg-bake-star]');
    if (star) {
      var r = Number(star.getAttribute('data-vg-bake-star')), it = item() || { c: 0, t: '' };
      it.r = it.r === r ? 0 : r;
      save(it); render();
      status.textContent = it.r ? 'Rating saved. Only you see it unless you share a review.' : 'Rating cleared.';
      return;
    }
    if (e.target.closest('[data-vg-bake-undo]')) {
      save(lastLog && (lastLog.c || lastLog.t || lastLog.r) ? lastLog : null);
      lastLog = null;
      sub.textContent = 'Log it to keep your bakes, ratings and notes together in My Kitchen.';
      logBtn.textContent = 'I made this';
      render();
      status.textContent = 'Removed.';
      return;
    }
    if (e.target.closest('[data-vg-bake-save]')) {
      var it2 = item() || { c: 0, r: 0 };
      it2.t = (text.value || '').trim().slice(0, 280);
      if (!it2.c && !it2.r && !it2.t) save(null); else save(it2);
      render();
      status.textContent = it2.t ? 'Note saved. It will show at the top of this recipe next time.' : 'Note cleared.';
      track('bake_note_saved', { article_id: id });
      return;
    }
    if (e.target.closest('[data-vg-bake-review]')) {
      var it3 = item(), star5 = it3 && it3.r ? document.getElementById('VgStar' + it3.r) : null;
      if (star5) { star5.checked = true; star5.dispatchEvent(new Event('change', { bubbles: true })); }
      track('bake_review_click', { article_id: id });
    }
  });
  if (note) {
    var edit = note.querySelector('.vg-bnote__edit');
    if (edit) edit.addEventListener('click', function () { form.hidden = false; setTimeout(function () { if (text) text.focus(); }, 300); });
  }
  /* "Add to my week": the member's bake list (vg_plan_v1: { articleId: { n, u, i, a } }), shown on My Kitchen */
  var PLAN = 'vg_plan_v1', planBtn = $('[data-vg-plan]');
  function readPlan() { try { return JSON.parse(window.localStorage.getItem(PLAN) || '{}') || {}; } catch (e) { return {}; } }
  function renderPlan() {
    if (!planBtn) return;
    var on = !!readPlan()[id];
    planBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    planBtn.textContent = on ? 'On my week \u2713' : 'Add to my week';
  }
  if (planBtn) planBtn.addEventListener('click', function () {
    var plan = readPlan();
    if (plan[id]) delete plan[id];
    else {
      if (Object.keys(plan).length >= 12) { status.textContent = 'Your week already has 12 recipes. Tick some off in My Kitchen first.'; return; }
      plan[id] = { n: (box.getAttribute('data-name') || '').slice(0, 200), u: (box.getAttribute('data-url') || '').slice(0, 290),
                   i: (box.getAttribute('data-img') || '').slice(0, 290), a: today() };
    }
    try {
      if (Object.keys(plan).length) window.localStorage.setItem(PLAN, JSON.stringify(plan)); else window.localStorage.removeItem(PLAN);
    } catch (e) { status.textContent = 'Your browser is blocking saves, so this was not kept.'; return; }
    renderPlan();
    status.innerHTML = plan[id] ? 'Added to your week. <a class="vg-bake__link" href="/pages/my-kitchen">See your bake list</a>' : 'Removed from your week.';
    track(plan[id] ? 'plan_add' : 'plan_remove', { article_id: id });
  });
  /* Member preferences from My Kitchen (vg_me.profile.prefs): grams first in the ingredient list, and no shopping
     prompts for equipment they already own. */
  (function () {
    var prefs = (window.vgMe && typeof window.vgMe.profile === 'function' && (window.vgMe.profile() || {}).prefs) || {};
    if (prefs.units === 'grams') {
      document.querySelectorAll('.recipe-article__ing-qty').forEach(function (q) {
        var metric = q.querySelector('.recipe-article__ing-metric');
        if (!metric || !q.querySelector('[data-amount]') || q.getAttribute('data-vg-grams')) return;
        var us = document.createElement('span');
        us.className = 'recipe-article__ing-us';
        while (q.firstChild && q.firstChild !== metric) us.appendChild(q.firstChild);
        metric.innerHTML = metric.innerHTML.replace(/^\s*\(/, '').replace(/\)\s*$/, '');
        var tail = String(us.textContent).trim();
        q.appendChild(document.createTextNode(' ('));
        q.appendChild(us);
        q.appendChild(document.createTextNode(')'));
        if (!tail) { us.remove(); q.lastChild.remove(); q.lastChild.remove(); }
        q.setAttribute('data-vg-grams', '1');
      });
    }
    var own = prefs.equipment || [];
    if (!own.length) return;
    var MATCH = { 'Stand mixer': /stand mixer/i, 'Hand mixer': /hand mixer/i, 'Food processor': /food processor/i, 'Kitchen scale': /scale/i,
                  'Instant-read thermometer': /instant.read|thermometer/i, 'Ice cream maker': /ice cream maker/i, 'Kitchen torch': /torch/i,
                  'Bread machine': /bread machine/i, 'Dutch oven': /dutch oven/i, 'Air fryer': /air fryer/i, 'Piping set': /piping/i,
                  'Espresso machine': /espresso machine/i };
    document.querySelectorAll('.vg-gear__item[data-vg-gear-click="amazon"]').forEach(function (a) {
      var name = a.getAttribute('data-vg-name') || '';
      var hit = own.some(function (k) { return MATCH[k] && MATCH[k].test(name); });
      if (!hit) return;
      var cta = a.querySelector('.vg-gear__cta');
      if (cta) cta.textContent = 'In your kitchen \u2713';
      a.removeAttribute('href'); a.removeAttribute('target');
      a.classList.add('vg-gear__item--own');
      a.style.opacity = '.72';
    });
  })();
  /* round 2: "I baked this" photos. Sent to VanillaGoods (sync service action 'bakephoto'), shown after approval. */
  var pOpen = $('[data-vg-photo-open]'), pForm = $('[data-vg-photo-form]');
  function shrink(file, done) {
    var rd = new FileReader();
    rd.onload = function () {
      var img = new Image();
      img.onload = function () {
        var s = Math.min(1, 1280 / Math.max(img.width, img.height)), c = document.createElement('canvas');
        c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        var q = 0.82, data = c.toDataURL('image/jpeg', q);
        while (data.length > 900000 && q > 0.4) { q -= 0.12; data = c.toDataURL('image/jpeg', q); }
        done(data);
      };
      img.onerror = function () { done(''); };
      img.src = rd.result;
    };
    rd.onerror = function () { done(''); };
    rd.readAsDataURL(file);
  }
  if (pOpen && pForm) {
    pOpen.addEventListener('click', function () {
      if (!(window.vgMe && window.vgMe.signedIn)) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(location.pathname + '#VgBake');
        return;
      }
      pForm.hidden = !pForm.hidden;
      pOpen.setAttribute('aria-expanded', pForm.hidden ? 'false' : 'true');
      if (!pForm.hidden) track('bake_photo_open', { article_id: id });
    });
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fileIn = $('[data-vg-photo-file]'), btn = $('[data-vg-photo-send]'), file = fileIn.files && fileIn.files[0];
      if (!file) { status.textContent = 'Choose a photo first.'; fileIn.focus(); return; }
      if (!$('[data-vg-photo-agree]').checked) { status.textContent = 'Please confirm you took this photo.'; return; }
      btn.disabled = true;
      status.textContent = 'Sending your photo...';
      shrink(file, function (data) {
        if (!data) { btn.disabled = false; status.textContent = 'That photo could not be read. Try a JPG or PNG.'; return; }
        window.vgMe.send('bakephoto', { image: data, recipe: { id: id }, caption: ($('[data-vg-photo-cap]').value || '').trim().slice(0, 200), agree: true })
          .then(function (res) {
            btn.disabled = false;
            if (!res || !res.ok) { status.textContent = (res && res.error) || 'Could not send the photo. Please try again.'; return; }
            pForm.reset(); pForm.hidden = true; pOpen.setAttribute('aria-expanded', 'false');
            status.textContent = 'Thank you! Your photo will appear here and on your baker page once we approve it.';
            var it = item();
            if (it) { it.p = today(); save(it); }
            track('bake_photo_sent', { article_id: id });
          });
      });
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); if (e.key === PLAN) renderPlan(); });
  window.addEventListener('vgme:change', renderPlan);
  renderPlan();
  window.addEventListener('vgme:change', render);
  render();
})();
